import type { ChatTier } from '../types';

interface TierBadgeProps {
  tier: ChatTier;
}

const labels: Record<ChatTier, string> = {
  FREE: 'FREE',
  PRO_CREDITS: 'PRO · credits',
  PRO_SUB: 'PRO · sub'
};

const styles: Record<ChatTier, string> = {
  FREE: 'bg-gray-50 text-gray-700 border-gray-200',
  PRO_CREDITS: 'bg-blue-50 text-blue-700 border-blue-200',
  PRO_SUB: 'bg-primary-50 text-primary-700 border-primary-200'
};

export function TierBadge({ tier }: TierBadgeProps) {
  return (
    <span
      data-testid={`tier-badge-${tier}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${styles[tier] ?? ''}`}
    >
      {labels[tier] ?? tier}
    </span>
  );
}
